<template>
	<div class="enterparise_guide por" id="enterlist-menu"  >
		<div class="notion_slide" v-show="notionslide" >
			<div class="notiontitle">
				<span class="notiontitle1">一级分类</span>
				<span class="notiontitle2">二级分类（细分产业）</span>
				<span class="notiontitle3">三级分类（产业链环节）</span>
			</div>
			<div class="notion_li" v-for="list in notionlist1">
				<h5 @click="notionclickfun(list.label,list.value);notionslide=false;notionslide1=false;showmorecitydata=false;notionslide3=false;" :class="usernotionid == list.value ?' current title notiontitle1':'title notiontitle1'">{{list.label}} <em v-if="list.count!=undefined && list.count>0">({{list.count}})</em> </h5>
				<div class="fl">
					<div class="seconslide oh" v-if="list.children!=null" v-for="list1 in list.children" >
						<strong @click="notionclickfun(list1.label,list1.value);notionslide=false;notionslide1=false;showmorecitydata=false;notionslide3=false;" :class="usernotionid == list1.value ?'current notiontitle2':'notiontitle2'">{{list1.label}} <em v-if="list1.count!=undefined && list1.count>0">({{list1.count}})</em></strong>
						<div class="thirdslide notiontitle3">
							<span :class="usernotionid == list2.value ?'slide_a current':'slide_a '" v-if="list1.children!=null" v-for="list2 in list1.children" @click="notionclickfun(list2.label,list2.value);notionslide=false;notionslide1=false;showmorecitydata=false;notionslide3=false;">{{list2.label}}<em v-if="list2.count!=undefined && list2.count>0">({{list2.count}})</em></span>
						</div> 
					</div> 
				</div> 
			</div> 
			<div class="fr listclose_btn" @click="notionslide=false;notionslide1=false;showmorecitydata=false;notionslide3=false;">关闭</div>
		</div> 
		<div class="notion_slide1" v-show="notionslide1" v-if="selectcitydata.length>0">
			<h5  @click="choosecityid(0,1);notionslide=false;notionslide1=false;showmorecitydata=false;notionslide3=false;" :class="cityid == 0?'current title1':'title1'">全国城市<em>({{total1}})</em></h5>
			<div class="notion_li1" v-for="(list,index) in selectcitydata" v-if="index<10">
				<h5  @click="choosecityid(list.id,1,list.name);notionslide=false;notionslide1=false;showmorecitydata=false;notionslide3=false;" :class="list.id == provienceid?'current title':'title'">{{list.name}}<em>({{list.count}})</em></h5>
				<div class="fl"><span  v-for="item in list.children" @click="choosecityid(item.id,2,item.name);notionslide=false;notionslide1=false;showmorecitydata=false;notionslide3=false;" :class="item.id == cityid?'current':''">{{item.name}}<em>({{item.count}})</em></span></div>
			</div>
			<div class="morecitydata" v-if="selectcitydata.length>10" v-show="showmorecitydata"> 
				<div class="notion_li1" v-for="(list,index) in selectcitydata" v-if="index>9">
					<h5  @click="choosecityid(list.id,1,list.name)" :class="list.id == provienceid?'current title':'title'">{{list.name}}<em>({{list.count}})</em></h5>
					<div class="fl"><span  v-for="item in list.children" @click="choosecityid(item.id,2,item.name);notionslide=false;notionslide1=false;showmorecitydata=false;notionslide3=false;" :class="item.id == cityid?'current':''">{{item.name}}<em>({{item.count}})</em></span></div>
				</div> 
			</div>
			<div class="showmorecity" v-text="showmorecitydata?'隐藏更多城市':'展开显示更多'" @click="showmorecitydata=!showmorecitydata"></div>
			<div class="fr listclose_btn" @click="notionslide=false;notionslide1=false;showmorecitydata=false;notionslide3=false;">关闭</div>
		</div>
		<div class="notion_slide3" v-show="notionslide3">
			<div class="citymapblock por">
				<chainMap :mapdata="citymapdata" v-if="citymapdata.length>0" :citymapflag="true" v-on:chartmapclick="chartmapclick" :choosecity='choosecity'></chainMap>
				<div class="conallEnterprise_pie" id="conallEnterprise_pie" ></div>
				<div class="listclose_btn" @click="notionslide=false;notionslide1=false;showmorecitydata=false;notionslide3=false;">关闭</div>
			</div>
		</div>
		<div class="w95mg por"> 
		<h5 class="fl menuicon">分类导航</h5>  
		<div class="notionlist_block" >
			<div class="titlebox">
				<h5 class="title"   @mouseover="notionslide=true;notionslide1=false;notionslide3=false;showslidenotion(index)" v-for="(list,index) in notionlist">{{list.label}}</h5> 
				<h5 class="title" @mouseover="notionslide1=true;notionslide=false;notionslide3=false;" v-if="selectcitydata.length>0">城市选择</h5> 
				<h5 class="title" @mouseover="notionslide1=false;notionslide=false;notionslide3=true;" v-if="citymapdata.length>0">招商地图</h5>
				<!-- <span class="othersearch" @click="othersearch" v-show="searchtype == 2">高级搜索</span> -->
			</div> 
		</div>
		<div class="s_screen_choose" >
			<span class="span-screen" v-for="(item,index) in usernotionlist" :data="item.id" v-show="usernotionlist.length>0">{{item.name}}<i @click="ckll()" class="concept_notionlist el-icon-close" ></i></span>
			<span class="span-screen" v-show="choosecitydata.name!=''">{{choosecitydata.name}}<i @click="chartmapclick('');choosecity=true;choosecitydata ={name:''}" class="concept_notionlist el-icon-close" ></i></span>
		</div> 
		<!-- <p class="fr">产业招商大脑为您找到<span class="searchnum">{{total}}</span>条匹配的{{texts}}</p> -->
		</div>
	</div>
</template> 
<script>
	export default {
	  name: 'listmenu',
			data(){
				return{
					islogin:false, 
					notionslide:true,
					notionslide1:false,
					notionslide3:false,
					showmorecitydata:false, 
					cityflag:false, 
					notionlist1:{},
					notionlist2:{},
					provienceid:0,
					cityid:0,  
					usernotionlist:[],
					usernotionid:0,
					choosecity:false,
					choosecitydata:{name:''},
			}}, 
			// watch:{
			// 	notionlist:{
			// 		handler(newValue,oldValue){ 
			// 			this.type=newValue;  
			// 		}  
			// 	}, 
			// },
	  props: {
	  	notionlist: {
						type: Array, 
						default:[],
				} , 
				citymapdata:{
					type: Array, 
				} , 
				selectcitydata: {
					type: Array, 
				} , 
				total:Number,
				total1:Number,
				texts:String,
				searchtype:Number,
	  },
			computed: {
			 
			},
			methods: {
				ckll(){
					this.notionclickfun('','');
						this.usernotionlist=[];
				},
				setPage: function(item) { 
					if(item.class == '') {
						this.$emit('pagehandler', item.page);
					}
				},
				othersearch(){
					this.routerlinkarry('/search',{type:this.searchtype}); 
				},
				showslidenotion(inds){
					// console.log('listmenu',this.notionlist);
					this.notionlist1=this.notionlist[inds].children;
					// console.log(this.notionlist1);
				},
				notionclickfun(name,id){
					let adde=[{name:name,id:id}];
					this.$emit('notionclickfun', adde); 
					this.usernotionlist=adde;
					this.usernotionlistsave=adde; 
					this.usernotionid=id;
				},
				choosecityid(id,type,name){
					if(type == 1){
						this.provienceid=id;
						this.cityid=0;
					}else{
						this.provienceid=0;
						this.cityid=id;
					}  
					this.notionslide1=false;
					this.choosecitydata={name:name};
					this.$emit('choosecityide', [id,type]); 
				}, 
				chartmapclick(data){
					var type="";
					if(data.data!=undefined && data.data.length>0){ 
						type=1;
					};
					this.choosecityid(data.id,type);
					this.notionslide3=false;
					this.$emit('chartmapclick', data); 
					// console.log('选中的地图数据',data);
					this.choosecitydata = data;  
				}, 
			},
			created() {
			 
			},
			mounted() {
				console.log('初始化后notionlist',this.notionlist)
				this.showslidenotion(0);
			 // this.total1=this.total;
				// console.log('listmenu',this.selectcitydata)
				// console.log(this.notionlist); 
				// console.log(this.notionlist[1].children);
			},
	}
	
	
	
</script>

<style> 
	
	
</style>
